export const isClient = (): boolean => {
  return (
    typeof window !== "undefined" ||
    typeof self !== "undefined" ||
    typeof global !== "undefined" ||
    typeof process !== "object"
  );
};
